/* global $ */
import { Swiper, Navigation, Pagination, Autoplay, EffectFade } from 'swiper/dist/js/swiper.esm.js'
import './swiper.css'

Swiper.use([Navigation, Pagination, Autoplay, EffectFade])

function init () {
  $(document).ready(function () {
    // initialize swiper when document ready
    const swiperElem = $('.swiper-container.hero-swiper')
    if (swiperElem.length === 0) {
      return
    }
    let loopVal = false
    if ($(swiperElem).find('.swiper-slide').length > 1) {
      // loop only if swiper has more than 1 slide
      loopVal = true
    }
    const swiper = new Swiper(swiperElem, {
      fadeEffect: {
        crossFade: true
      },
      effect: 'fade',
      speed: 2000,
      loop: loopVal,
      watchOverflow: true,
      autoHeight: false,
      centeredSlides: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: true
      },
      pagination: {
        el: $(swiperElem).find('.swiper-pagination'),
        clickable: true
      },
      navigation: {
        nextEl: $(swiperElem).find('.swiper-button-next'),
        prevEl: $(swiperElem).find('.swiper-button-prev')
      }
    })
    swiper.init()
  })
}

export default {
  init
}
